import React from "react";
import { Spinner } from "react-bootstrap";
import { COLOR_APP, COLOR_TEXT } from "../constants";

export default function LoadingSpinner() {
  return (
    <div
      style={{
        width: "100%",
        height: "50vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection:'column',
        gap:10
      }}>
      {/* <Spinner size="xl" style={{ color: COLOR_TEXT }} /> */}
      <img src="https://cdnl.iconscout.com/lottie/premium/thumb/loading-dots-5711314-4752314.gif" style={{width:150, height:80}} />
      <p>ກຳລັງໂຫລດຂໍ້ມູນໃໝ່...</p>
    </div>
  );
}
